import React from 'react';
import MaterialIcon from '@lib/components/MaterialIcon/MaterialIcon';
import Tooltip from '@lib/components/Tooltip/Tooltip';
import styles from './CompanyPlanView.module.scss';

export interface PlanInfoTooltipIconProps {
  body: string;
}

/** The muted "info" affordance next to a plan label or section title. */
export default function PlanInfoTooltipIcon({
  body,
}: PlanInfoTooltipIconProps) {
  return (
    <Tooltip body={body}>
      <MaterialIcon
        cursor="help"
        icon="info"
        symbolsOutlined
        size="md-16"
        className={styles.infoIcon}
      />
    </Tooltip>
  );
}
